<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isAuctionManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{header}} Bid History</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>
			<!--<button @click="movedata">click</button>-->
    <!-- Main content -->
    <section class="content">
			<br>
    <!-- /.content -->
			<p v-for="(data,index) in bids.slice().reverse()" :key="index"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>  <span style="color: #1fa67a">{{data.bid_price}}</span> was raised by {{data.buyer}}</p>
		</section>

    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isAuctionManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getShit();
        },
        
        data() {
        	return{
        		bids: [],
        		header: ''
        	}
        },
        
        methods: {
        	getShit(){
        		axios.post("/api/showBidsHistory", {id: this.$route.params.id})
       			.then(response => {
       				this.bids = response.data;
       			})
       			axios.post("/api/getLotDetails", {id: this.$route.params.lot_id})
        		.then(response => {
        			this.header = response.data.name;
        		})
        	},
        	
        	/*movedata(){
        		axios.post("/api/movedata", {id: this.$route.params.id})
        		.then(response => {
        			toast.fire({
        				title: 'moved',
        				type: 'success'
        			});
        		})
        	}*/
        }
    }
</script>
